<template>
  <section>
    <div :class="tamanhoClasse">
      <h3 class="texto-quantidade">Quantidade:</h3>
      <div class="div-botoes-quantidade">
        <button class="botao-aumentar-diminuir" @click="diminuir">
          <img class="imagem" src="../../assets/icons/menos.png" alt="" />
        </button>
        <span class="quantidade"> {{ this.quantidade }} </span>
        <button class="botao-aumentar-diminuir" @click="aumentar">
          <img class="imagem" src="../../assets/icons/mais.png" alt="" />
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "QuantidadeEscolher",
  props: {
    quantidade: Number,
    diminuir: Function,
    aumentar: Function,
    tamanho: { type: String, default: "grande" },
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    tamanhoClasse() {
      return this.tamanho === "pequeno" ? "componente-pequeno" : "componente-grande";
    },
  },
};
</script>

<style scoped>
.div-botoes-quantidade {
  display: flex;
  align-items: center;
}
.texto-quantidade {
  color: black;
  margin-block: 0px;
  font-weight: bold;
}
.botao-aumentar-diminuir {
  background: white;
}

/* ------ MODO PEQUENO ------ */
.componente-pequeno {
  align-items: center;
  justify-content: flex-end;
  display: flex;
}
.componente-pequeno > .texto-quantidade {
  font-size: 0.7rem;
}
.componente-pequeno .quantidade {
  font-size: 16px;
}
.componente-pequeno .imagem {
  width: 20px;
}
/* ------ MODO GRANDE ------ */
.componente-grande {
  align-items: center;
  justify-content: space-between;
  display: flex;
  margin-inline: 20px;
}
.componente-grande .imagem {
  width: 30px;
}
.componente-grande .quantidade {
  font-size: 26px;
  font-weight: bold;
  padding-block: 5px;
}
</style>
